export const JWT_COOKIE_KEY = 'wap_session';
export const JWT_COOKIE_NEEDS_REFRESH_AT_KEY = 'wap_session_refresh_at';
export const JWT_COOKIE_CONFIG = {
    maxAge: 31557600, // 1 year
    sameSite: 'lax',
} as const;
